<template>
    <div class="position-fixed h-100 w-100 d-flex flex-row"
         :style="showHeader ? 'padding-top:45px' : ''">
        <!--        <div v-if="showSidebar" class="app-sidebar__overlay" data-toggle="sidebar"></div>-->
        <aside v-if="showSidebar" class="app-sidebar sidebar-style d-flex flex-column">
            <ul class="app-menu menu-style">
                <li v-for="module in modules" :key=module.id class="app-menu-li">
                    <div class="app-menu__item menu-item-style"
                         :class="{ 'is-current': module.id === activeModuleId }"
                         :href="baseMenuUrl + module.url">
                        <!-- <a :href="baseMenuUrl + module.url" style="color: white;"> -->
                        <i :class="iconClass + module.cssIconClass"></i>
                        <span class="app-menu__label cursor-pointer">{{ $t(module.nameIl8n) }}</span>
                        <!-- </a> -->
                        <div class="app-submenu sub-menu-style">
                            <h3>{{ $t(module.nameIl8n) }}</h3>
                            <hr/>
                            <div v-for="component in module.component" :key=component.id class="mb-3">
                                <h5>{{ $t(component.nameIl8n) }}</h5>
                                <ul class="list-group list-group-flush">
                                    <template v-for="children in component.children">
                                        <li class="list-group-item list-group-item-over menu-title cursor-pointer"
                                            :key=children.id
                                            @click="routeTo(children)">
                                            <span>{{ $t(children.nameIl8n) }}</span>
                                        </li>
                                    </template>
                                </ul>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>

            <span class="app-sidebar__toggle position-sticky mt-auto toggle-btn-cover"
                  data-toggle="sidebar"
                  aria-label="Hide Sidebar"
                  @click="toggleSidebarState">
                    <i class="fas fa-angle-double-right" v-if="showCollapse"></i>
                    <i class="fas fa-angle-double-left" v-else></i>
            </span>
        </aside>
        <div class="flex-grow-1 router-view-body">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>

import {mapActions, mapState} from "vuex";

export default {
    name: "mmf-sidebar",
    props: ['baseApiUrl', 'userId'],
    data: function () {
        return {
            homeMenuId: 182,
            modules: [],
            iconClass: "app-menu__icon fa ",
            baseMenuUrl: process.env.BASE_URL,
            menuRouteConfigs: {},
        };
    },
    computed: {
        ...mapState({
            showHeader: state => state.base.showHeader,
            showSidebar: state => state.base.showSidebar,
            showCollapse: state => state.base.showCollapse,
        }),
        // 根据当前路由定位所属的一级菜单（module），用于高亮（复用 hover 样式）。
        // 当前页由 route.query.menuId 标识（三级菜单 id），逐级向上匹配其所属 module；
        // 无 menuId 时回退用 route.path 与三级菜单 url 匹配。
        activeModuleId() {
            if (!this.modules || this.modules.length === 0) {
                return null;
            }
            const menuId = this.$route.query.menuId;
            const currentPath = this.$route.path;
            for (const module of this.modules) {
                if (menuId != null && String(module.id) === String(menuId)) {
                    return module.id;
                }
                for (const component of (module.component || [])) {
                    if (menuId != null && String(component.id) === String(menuId)) {
                        return module.id;
                    }
                    for (const child of (component.children || [])) {
                        if (menuId != null && String(child.id) === String(menuId)) {
                            return module.id;
                        }
                        if ((menuId == null || menuId === '') && currentPath && child.url === currentPath) {
                            return module.id;
                        }
                    }
                }
            }
            return null;
        },
    },
    methods: {
        toggleSidebarState: function () {
            this.$store.commit('base/setShowCollapse', !this.showCollapse);
        },
        getModules() {
            let _this = this
            this.$store.dispatch("api/get", {
                url: (process.env.VUE_APP_EM_ADMIN_URL + "/emMenu/getHomeMenu/" + this.homeMenuId),
                commonErrorHandle: false,
                originResponse: true
            }).then(response => {
                _this.modules = response.data;
                this.readMenuConfig();
            }).catch(error => {
                if (error.response.status === 405) {
                    let v = confirm("You should change your password first!");
                    if (v) {
                        this.$router.push("/em/emUserCenter?force=true");
                    }
                } else {
                    this.$store.dispatch('error', error);
                }
            })
        },
        readMenuConfig() {
            let tempRouteConfig = {};
            if (this.modules) {
                for (let m of this.modules) {
                    let cList = m.component;
                    if (cList) {
                        for (let component of cList) {
                            let ccList = component.children;
                            for (let item of ccList) {
                                let configJson = item.menuConfig;
                                if (configJson) {
                                    try {
                                        tempRouteConfig[item.id] = JSON.parse(configJson);
                                    } catch (e) {// eslint-disable-current-line no-empty
                                    }
                                }
                            }
                        }
                    }
                }
            }
            this.menuRouteConfigs = tempRouteConfig;
        },
        routeTo(children) {
            let location = {
                path: children.url,
                query: {
                    menuId: children.id,
                    pathType: children.crudCode
                },
                params: {}
            };
            this.installConfig(children, location);
            this.$interaction({
                identifyCode: 'menu-route-to',
                actionName: 'click',
                actionContent: location.path
            })
            this.$router.push(location);
        },
        installConfig: function (children, location) {
            let config = this.menuRouteConfigs[children.id];
            if (config) {
                if (config.noDefaultQuery) {
                    location.query.noDefaultQuery = config.noDefaultQuery;
                }
                if (config.queryTag) {
                    location.query.queryTag = config.queryTag;
                }
                if (config.viewSwitchAble) {
                    location.query.viewSwitchAble = config.viewSwitchAble;
                }
            }
        },
        ...mapActions("emMenu", ["retrieveForUserAclsAndRoles"]),
    },
    mounted: function () {
        var me = this;
        me.toggleSidebarState();
        //获取菜单
        this.getModules();
        // 获取当前用户权限
        this.retrieveForUserAclsAndRoles();
    }
};
</script>


<style scope>
.list-group-item-over {
    border: 0 !important;
    border-top: 1px solid rgba(0, 0, 0, 0.125) !important;
}

.sidebar-style {
    height: 100% !important;
    overflow: unset !important;
    position: sticky !important;
    top: 0 !important;
}

.menu-style {
    overflow-y: auto;
}

.menu-style::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
}

.menu-item-style {
    position: unset !important;
}

.sub-menu-style {
    left: 100% !important;
    position: absolute !important;
    top: 0 !important;
}

.sub-menu-style::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
}

.router-view-body {
    overflow: auto;
    height: 100%;
    position: relative;
}

.router-view-body .app-title {
    position: sticky !important;
    margin-left: 0 !important;
    top: 0 !important;
}

.router-view-body .app-content {
    margin-left: 0 !important;
    margin-top: 0 !important;
}
</style>

<style scoped lang="scss">
@media (max-width: 767px) {
    .toggle-btn-cover {
        display: none;
    }
}
</style>
